/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './BattleOpinion.css';
import ReactEcharts from 'echarts-for-react'
import * as echarts from 'echarts'
import moment from 'moment'



const list=[
    {
        class:'总值',
        type:'all'
    },
      {
        class:'微博',
        type:'wb'
      },{
        class:'微信',
        type:'wx'
      },{
        class:'知乎',
        type:'zh'
      },{
        class:'今日头条',
        type:'tt'
      }
    ]
let propsDataJson=[]



class BattleOpinion extends React.Component {

  constructor(props){
    super(props)
    this.state={
      active:'all'
    }
    this._t=null
    this.isSelectCon=false

    this.getOption=this.getOption.bind(this)
    this.onChartReadyCallback=this.onChartReadyCallback.bind(this)
    this.enSelectCon=this.enSelectCon.bind(this)
    this.ovSelectCon=this.ovSelectCon.bind(this)
  }

  enSelectCon=()=>{
      console.log('en')
      this.isSelectCon=true
  }

  ovSelectCon=()=>{
      console.log('ov')
      this.isSelectCon=false
  }


  

  getOption=()=>{

    let propsData=this.props.json.all[0]||[
        {
          name:'腾讯',
          wb:[100,200,300,400],
          wx:[134,222],
          zh:[400,200,500],
          tt:[400,300]
        },{
          name:'阿里巴巴',
          wb:[100,200,300,400],
          wx:[400,200],
          zh:[140,222,444],
          tt:[200,300]
        },{
          name:'美的',
          wb:[200,300,100,500],
          wx:[100,490],
          zh:[100,299,599],
          tt:[111,300]
        }
      ]
    //   let calendarData=this.props.json[this.state.active]
    // const myChart=this.echarts_react.init(document.getElementById,'main')
    // let calendarData=this.props.json[this.state.active]
    

    let legendArr=[]

    propsData.forEach((i)=>{
        legendArr.push(`${i.name}`)
    })

    let timeArr=[] 
    

    let getTimeArr=()=>{
        let time= moment(this.props.time,'YYYY-MM-DD').add(1,'days')
        
        for (var i = 0; i <7; i++) {
            timeArr.unshift(time.subtract(1,'days').format('MM-DD'))
        }
        
    }
    getTimeArr()
    // console.log(legendArr,this.props.time,timeArr)
  
    
    var cellSize = [120, 90];
    


    const option = {
        title: {
            // text: `KOL参与图 -${this.props.items.name} `,
            text: `口碑舆情图 -${legendArr.join(' vs ')} `,
            subtext: '数据来源：数字品牌榜',
            x: '20'
        },
        color:['#ffd70d','#608f9f','#014d67','#56b5a0','#248e76'],
        
        tooltip : {},
        toolbox: {
            show: true,
            feature: {
                restore: {},
                saveAsImage: {}
            },
            right: 20
        },
        legend: {
            // selectedMode: false,
            orient: 'vertical',
            right: 10,
            bottom: 10,
            data:legendArr,
        },
        graphic: [
            
            {
                type: 'group',
                left: '8%',
                top: 'center',
                children: [
                    
                    {
                        type: 'text',
                        z: 100,
                        left: 'center',
                        top: '-180',
                        style: {
                            fill: '#333',
                            text: [
                                '推荐'
                            ],
                            font: '16px Microsoft YaHei'
                        }
                    },{
                        type: 'text',
                        z: 100,
                        left: 'center',
                        top: '-90',
                        style: {
                            fill: '#333',
                            text: [
                             '好感'
                            ],
                            font: '16px Microsoft YaHei'
                        }
                    },{
                        type: 'text',
                        z: 100,
                        left: 'center',
                        top: 'middle',
                        style: {
                            fill: '#333',
                            text: [
                             '中立'
                            ],
                            font: '16px Microsoft YaHei'
                        }
                    },{
                        type: 'text',
                        z: 100,
                        left: 'center',
                        top: '90',
                        style: {
                            fill: '#333',
                            text: [
                             '差评'
                            ],
                            font: '16px Microsoft YaHei'
                        }
                    },{
                        type: 'text',
                        z: 100,
                        left: 'center',
                        top: '180',
                        style: {
                            fill: '#333',
                            text: [
                                '反感'
                            ],
                            font: '16px Microsoft YaHei'
                        }
                    },
                ]
            }],
 
        calendar: {
            top: 'middle',
            left: 'center',
            orient: 'vertical',
            cellSize: cellSize,
            yearLabel: {
                show: false,
                textStyle: {
                    fontSize: 30
                }
            },
            dayLabel: {
                margin: 20, 
                // firstDay: 1,
                nameMap: timeArr,
                position:"end",
            },
            monthLabel: {
            //   nameMap:['推荐','好感','中立','差评','反感']
            show:false
            },
            range: ['2015-02-01','2015-03-07'],
            splitLine:{
                show:false,
            },
            itemStyle:{
                color:'red',
                borderType:'dashed',
                borderColor:'#ffd70d',
            }
        },
        series: [{
            id: 'label',
            type: 'scatter',
            coordinateSystem: 'calendar',
            symbolSize: 1,
            label: {
                normal: {
                    // show: true,
                    formatter: function (params) {
                        return echarts.format.formatTime('dd', params.value[0]);
                    },
                    offset: [-cellSize[0] / 2 + 10, -cellSize[1] / 2 + 10],
                    textStyle: {
                        color: '#000',
                        fontSize: 14
                    }
                }
            },
            data: []
        }]
    }
  
    return option

  }



  reSetOption=()=>{
    const charts=this.echarts_react.getEchartsInstance()
    propsDataJson=this.props.json[this.state.active]
    var cellSize = [120,90];
    var pieRadius = 40;
    

    
    function getVirtulData() {
        var date = +echarts.number.parseDate('2015-02-01');
        var end = +echarts.number.parseDate('2015-03-08');
        var dayTime = 3600 * 24 * 1000;
        var data = [];
        for (var time = date; time < end; time += dayTime) {
            data.push([
                echarts.format.formatTime('yyyy-MM-dd', time),
                Math.floor(Math.random() * 10000)
            ]);
        }
        return data;
    }

    
    
    function getPieSeries(scatterData, chart) {

        return echarts.util.map(scatterData, function (item, index) {
            var center = chart.convertToPixel('calendar', item);

            return {
                id: index + 'pie',
                type: 'pie',
                center: center,
                label: {
                    normal: {
                        formatter: '',
                        position: 'inside'
                    }
                },
        
                radius: pieRadius,
                
                data:propsDataJson[index]
            };
        });
    }
    
    function getPieSeriesUpdate(scatterData, chart) {
        return echarts.util.map(scatterData, function (item, index) {
            var center = chart.convertToPixel('calendar', item);
            return {
                id: index + 'pie',
                center: center
            };
        });
    }
    
    var scatterData = getVirtulData();
    // var center = echarts.convertToPixel('calendar', item);
    
    const option = {
        tooltip : {},
        legend: {
            data: ['工作', '娱乐', '睡觉'],
            bottom: 20
        },
        // color:['#ffd70d','#608f9f','#014d67'],
        calendar: {
            top: 'middle',
            left: 'center',
            orient: 'vertical',
            cellSize: cellSize,
            yearLabel: {
                show: false,
                textStyle: {
                    fontSize: 30
                }
            },
            dayLabel: {
                margin: 20,
                // firstDay: 1,
                nameMap: [ '星期一', '星期二', '星期三', '星期四', '星期五', '星期六','星期日',]
            },
            monthLabel: {
            //   nameMap:['推荐','好感','中立','差评','反感']
            show:false
            },
            range: ['2015-02-01','2015-03-07'],
            splitLine:false,
            
        },
        series: [{
            id: 'label',
            type: 'scatter',
            coordinateSystem: 'calendar',
            symbolSize: 1,
            label: {  
                normal: {
                    // show: true,
                    formatter: function (params) {
                        return echarts.format.formatTime('dd', params.value[0]);
                    },
                    offset: [-cellSize[0] / 2 + 10, -cellSize[1] / 2 + 10],
                    textStyle: {
                        color: '#000',
                        fontSize: 14
                    }
                }
            },
            data: scatterData,
           
        }]
    };
    
    
    charts.setOption({
        series: getPieSeries(scatterData, charts)
    });
 
  }

  onChartReadyCallback=(chart)=>{
    //   chart.setOption({
    //     xAxis: {
    //         type: 'category',
    //         data: ['23','4',5]
    //     },
    //     yAxis: {
    //         type: 'value'
    //     },
    //     series: [{
    //         data: [820, 932, 901, 934, 1290, 1330, 1320],
    //         type: 'line'
    //     }]
    //   });
      const self=this
      this._t = setTimeout(function() {
        self.reSetOption()
      }, 0);
  }


  componentWillUnmount() {
    clearTimeout(this._t);
  };
  


  render() {
    // console.log(option.series)
    

    return (
    <div className={s.root}>
      <select 
        value={this.state.active}
        onChange={(e)=>{
            this.setState({active:e.target.value})
            this.onChartReadyCallback()
            }}
            className={s.selectLayout}
      >
            {list.map(i=><option key={i.type} value={i.type}   >{i.class}</option>)}
      </select>
      {/* <div tabIndex='0' className={s.selectLayout} 
        onBlur={()=>console.log('onBlur')}
        >
        addasdasadsasdadsads
          <ul onMouseEnter={()=>this.enSelectCon()} onMouseOver={()=>this.ovSelectCon()} >
            {this.isSelectCon?list.map(i=><li key={i.type} value={i.type} onClick={(e)=>{
                this.setState({active:i.type})
                this.onChartReadyCallback()
                
                }}>{i.class}</li>)
            :null}
          </ul>
      </div> */}
      <ReactEcharts 
        ref={(e) => { this.echarts_react = e; }}
        option={this.getOption()}
        style={{
        height: '550px',
        width:'100%',
        
        borderRadius: '4px'
        }}
        
        id='main'
        className={s.charts}
        theme={"theme_name"}

        onChartReady={this.onChartReadyCallback}/>
    </div>
      
    )


   
  }
}

export default withStyles(s)(BattleOpinion);



// WEBPACK FOOTER //
// src/components/BattleOpinion/BattleOpinion.js